export const STORAGE_KEYS = {
  TOKEN: "cms_admin_token",
  REFRESH_TOKEN: "cms_admin_refresh_token",
  USER: "cms_admin_user",
};
